/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import BaseCom from "./BaseCom";
import Card from "./Card";
import FormInput from "./FormInput";
import FormLabel from "./FormLabel";
import countries from "../dicts/countries.json"
import statesUSA from "../dicts/states-usa.json"
import statesCanada from "../dicts/states-canada.json"
import { qreq } from "../shared/qrequest";

export default class Address extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            item: props.item,
            typeList: []
        };
        this.title = props.title;
        if (!this.title)
            this.title = 'Address';
        this.state.readOnly = props.readOnly ? props.readOnly : false;
        this.onChange = props.onChange;
        this.load = this.load.bind(this);
        this.onCountryChange = this.onCountryChange.bind(this);
    }

    async componentDidMount() {
        await this.getSettings();
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (this.props.item !== prevProps.item) {
            this.setState({ item: this.props.item });
            this.checkGeoRestrict();
        }
        else {
            for (var k in this.props.item) {
                if (this.props.item[k] !== prevProps.item[k])
                    this.setState({ item: this.props.item });
            }
            this.checkGeoRestrict();
        }
        if (this.props.readOnly !== prevProps.readOnly) {
            this.setState({ readOnly: this.props.readOnly });
        }
        if(this.props.typeSelect !== prevProps.typeSelect)
            this.load();
    }

    load() {
        if(this.props.typeSelect) {
            qreq.get('/api/address/type/list', j => {
                if(j.list)
                    this.setState({ typeList: j.list });
            });
        }
        this.checkGeoRestrict();
    }

    checkGeoRestrict = () => {
        if(this.state.GEORESTRICT === 'USA') {
            if(this.state.item.country !== this.state.GEORESTRICT) {
                this.state.item.country = this.state.GEORESTRICT;
                this.setState({ item: this.state.item });
                this.props.onChange?.(this.state.item);
            }
        }
    }

    onCountryChange(obj) {
        this.state.item.country = obj;
        this.setState({ item: this.state.item });
        if (this.props.onChange)
            this.props.onChange(obj);
    }

    copyPrimary = () => {
        this.state.item.address1 = this.props.primary.address1;
        this.state.item.address2 = this.props.primary.address2;
        this.state.item.city = this.props.primary.city;
        this.state.item.state = this.props.primary.state;
        this.state.item.country = this.props.primary.country;
        this.state.item.zipCode = this.props.primary.zipCode;
        this.state.item.sameAsPrimary = true;
        this.setState({ item: this.state.item });
        this.props.onCopy?.(this.props.primary);
    }

    render() {
        if (this.props.condensed) {
            return (
                <div>
                    {this.props.title && <div className="fw-bold">{this.props.title}</div>}
                    <div>
                        {this.props.item.address1} {this.props.item.address2}<br />
                        {this.props.item.city}, {this.props.item.state} {this.state.GEORESTRICT ? '' : this.props.item.country} {this.props.item.zipCode}<br />
                    </div>
                </div>
            );
        }
        if (this.props.readOnly) {
            return (<Card title={this.title}>
                <div className="row">
                    <div className="col-md">
                        <FormLabel model={this.state.item.address1} label="Address Line 1" name="address1" type="text" required={this.props.required} />
                    </div>
                    <div className="col-md">
                        <FormLabel model={this.state.item.address2} label="Address Line 2" name="address2" type="text" required={false} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md">
                        <FormLabel model={this.state.item.city} label="City" name="city" type="text" required={this.props.required} />
                    </div>
                    <div className="col-md">
                        <FormLabel model={this.state.item.state} label="State" name="state" type="text" required={this.props.required} />
                    </div>
                    <div className="col-md">
                        <FormLabel
                            model={this.state.item.country}
                            label="Country"
                            name="country"
                            type="text"
                            required={this.props.required}
                            />
                    </div>
                    <div className="col-md">
                        <FormLabel model={this.state.item.zipCode} label="Postal Code" name="zipCode" type="text" required={this.props.required} />
                    </div>
                </div>  
            </Card>);
        }

        return (
            <Card title={this.title}>
                <div className="row">
                    <div className="col-md">
                        <FormInput model={this.state.item} label="Address Line 1" name="address1" type="text" required={this.props.required} onChange={this.props.onChange} />
                    </div>
                    <div className="col-md">
                        <FormInput model={this.state.item} label="Address Line 2" name="address2" type="text" required={false} onChange={this.props.onChange} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md">
                        <FormInput model={this.state.item} label="City" name="city" type="text" required={this.props.required} onChange={this.props.onChange} />
                    </div>
                    <div className="col-md">
                        {(this.state.item.country === 'USA' || this.state.item.country === 'Canada') ?
                            <FormInput model={this.state.item}
                                label="State/Province"
                                name="state"
                                type="select"
                                showID
                                required={this.props.required}
                                onChange={this.props.onChange}
                                options={this.state.item.country === 'USA' ? statesUSA.list : this.state.item.country === 'Canada' ? statesCanada.list : []}
                                /> : ''}
                    </div>
                    {!this.state.GEORESTRICT && <div className="col-md">
                        <FormInput
                            model={this.state.item}
                            label="Country"
                            name="country"
                            type="select"
                            disabled={this.state.GEORESTRICT}
                            required={this.props.required}
                            onChange={this.onCountryChange}
                            options={countries.list}
                            />
                    </div>}
                    <div className="col-md">
                        <FormInput model={this.state.item} label="Postal Code" name="zipCode" type="text" required={this.props.required} onChange={this.props.onChange} />
                    </div>
                </div> 
                {this.props.typeSelect ? <FormInput model={this.state.item} label="Address Type" name="addressTypeID" type="select" options={this.state.typeList} required={this.props.required} onChange={this.props.onChange} /> : ''}
                {this.props.primary && <div>
                    <button type="button" className="btn btn-secondary" onClick={() => this.copyPrimary()}>Copy Primary Address</button>
                </div>}
            </Card>
           );
    }
}